import { render, staticRenderFns } from "./zhhyRight.vue?vue&type=template&id=6512252e&scoped=true&"
import script from "./zhhyRight.vue?vue&type=script&lang=js&"
export * from "./zhhyRight.vue?vue&type=script&lang=js&"
import style0 from "./zhhyRight.vue?vue&type=style&index=0&id=6512252e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512252e",
  null
  
)

export default component.exports